













































import {
  computed,
  defineComponent, ref, useContext, useFetch, useRouter
} from '@nuxtjs/composition-api';
import loadBlogPosts from "~/customQueries/queries/loadBlogPosts.gql";
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";
import Newsletter from "~/components/Palmers/Newsletter.vue";
import CategoryPagination from "~/components/Palmers/Category/CategoryPagination/CategoryPagination.vue";
import {usePageBuilder, useUrl} from "~/composables/Palmers";
import {getMetaInfoVuePages} from "~/helpers/getMetaInfo";
import PageBuilder from "~/components/Palmers/PageBuilder/PageBuilder.vue";
export default defineComponent({
  name: 'PalmersStory',
  components: {
    CategoryPagination,
    PictureItem,
    Newsletter,
    PageBuilder
  },
  transition: 'fade',
  setup() {
    const {isPageBuilder} = usePageBuilder();
    const { getPageUrl, getMediaUrl } = useUrl();
    const loaded = ref(false);
    const router = useRouter();
    const page = computed(() => router.currentRoute.query.page || 1);
    const {$vsf} = useContext();
    const blogPosts = ref({
      all_post_size: 0,
      items: []
    })
    const totalPages = ref(0);
    const itemsPerPage = 9;
    const query = loadBlogPosts;

    const fetchData = async () => {
      //@ts-ignore
      const {amBlogPosts} = (await $vsf.$magento.api.customQuery({
        query: query,
        queryVariables: {
          ...(typeof page.value !== "undefined" && {page: page.value}),
          pageSize: itemsPerPage,
        }
      })).data;

      blogPosts.value = amBlogPosts || {items: []};
      totalPages.value = Math.ceil(blogPosts.value.all_post_size / itemsPerPage);

      loaded.value = true;
    };

    useFetch(fetchData);

    return {
      page,
      itemsPerPage,
      loaded,
      blogPosts,
      totalPages,
      getPageUrl,
      getMediaUrl,
      isPageBuilder,
      meta: getMetaInfoVuePages({
        title: "Palmers Stories"
      })
    }
  },
  head() {
    return this.meta;
  }
});
